import usePageType from './use-page-type';
import useMembershipShop from '../Pages/Membership/server-data/use-membership-shop';
import useBookingEditShop from '../Pages/BookingEdit/server-data/use-booking-edit-shop';
import useGiftcardMinimalShop from 'Pages/Giftcard/server-data/use-giftcard-minimal-shop';
import useBookingMinimalShop from 'Pages/Booking/server-data/use-booking-minimal-shop';

const useMinimalShopForPageType = () => {
  // Passing false to the useShop hooks, prevents them from initiating a new fetch
  // and instead returns the data from the cache if present.
  // This is done as the data fetching will be initiated in the page- and data-components for the active page type,
  // and we want to avoid fetching shop data for page types other than the currently active one.
  const { data: bookingMinimalShop } = useBookingMinimalShop(false);
  const { data: bookingEditShop } = useBookingEditShop(false); // No minimal shop this page type
  const { data: giftcardMinimalShop } = useGiftcardMinimalShop(false);
  const { data: membershipShop } = useMembershipShop(false); // No minimal shop this page type

  const pageType = usePageType();

  switch (pageType) {
    case 'booking': {
      return bookingMinimalShop;
    }
    case 'edit-booking': {
      return bookingEditShop;
    }
    case 'giftcard': {
      return giftcardMinimalShop;
    }
    case 'membership': {
      return membershipShop;
    }
    default: {
      return bookingMinimalShop;
    }
  }
};

export default useMinimalShopForPageType;
